import Inputmask from "inputmask/dist/inputmask.es6";

export function initInputMask() {
  Inputmask().mask(document.querySelectorAll(".inputmask"));
}
